module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1027-d5ebe429828710b688438f5e57a19262.png";